<template>
  <div>
    <input
      class="visually-hidden"
      :dusk="$attrs['input-dusk']"
      @change.prevent="handleChange"
      type="file"
      ref="fileInput"
      :multiple="multiple"
      :accept="acceptedTypes"
      :disabled="disabled"
      tabindex="-1"
    />

    <div class="space-y-4">
      <div v-if="files.length > 0" class="grid grid-cols-4 gap-x-6 gap-y-2">
        <FilePreviewBlock
          v-for="(file, index) in files"
          :file="file"
          @removed="() => handleRemove(index)"
          :rounded="rounded"
          :dusk="$attrs.dusk"
        />
      </div>

      <div
        tabindex="0"
        role="button"
        @click="handleClick"
        @keydown.space.prevent="handleClick"
        @keydown.enter.prevent="handleClick"
        class="block cursor-pointer rounded-2xl border border-dashed border-zinc-300 bg-zinc-50/70 p-4 transition hover:border-zinc-400 focus:outline-none focus:!border-primary-500 dark:border-zinc-700 dark:bg-zinc-900/50 dark:hover:border-zinc-600 md:p-6"
        :class="{ 'border-zinc-400 dark:border-zinc-500': startedDrag }"
        @dragenter.prevent="handleOnDragEnter"
        @dragleave.prevent="handleOnDragLeave"
        @dragover.prevent
        @drop.prevent="handleOnDrop"
      >
        <div
          class="pointer-events-none flex flex-col items-center gap-3 text-center md:flex-row md:items-center md:gap-4 md:text-start"
        >
          <Button
            as="div"
            class="panel-primary-btn !h-9 !min-h-0 w-full justify-center !px-4 !text-xs md:w-auto"
          >
            {{ multiple ? __('Choose Files') : __('Choose File') }}
          </Button>

          <p
            class="pointer-events-none text-sm font-medium leading-snug text-zinc-500 dark:text-zinc-400"
          >
            {{
              multiple
                ? __('Drop files or click to choose')
                : __('Drop file or click to choose')
            }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useLocalization } from '@/composables/useLocalization'
import { useDragAndDrop } from '@/composables/useDragAndDrop'
import { Button } from 'laravel-nova-ui'

const emit = defineEmits(['fileChanged', 'fileRemoved'])
const { __ } = useLocalization()

const props = defineProps({
  files: { type: Array, default: [] },
  multiple: { type: Boolean, default: false },
  rounded: { type: Boolean, default: false },
  acceptedTypes: { type: String, default: null },
  disabled: { type: Boolean, default: false },
})

const { startedDrag, handleOnDragEnter, handleOnDragLeave } =
  useDragAndDrop(emit)

const demFiles = ref([])
const fileInput = ref()

const handleClick = () => fileInput.value.click()

const handleOnDrop = e => {
  demFiles.value = props.multiple
    ? e.dataTransfer.files
    : [e.dataTransfer.files[0]]

  emit('fileChanged', demFiles.value)
}

const handleChange = () => {
  demFiles.value = props.multiple
    ? fileInput.value.files
    : [fileInput.value.files[0]]
  emit('fileChanged', demFiles.value)
  fileInput.value.files = null
}

const handleRemove = index => {
  emit('fileRemoved', index)
  fileInput.value.files = null
  fileInput.value.value = null
}
</script>

<script>
export default {
  inheritAttrs: false,
}
</script>
